export const nullifyEmptyFormValues = (obj: any) => {
  if (!obj || typeof obj !== 'object') {
    return obj && obj.length > 0 ? obj : null
  }

  return Object.fromEntries(
    Object.entries(obj).map(([key, value]) => [key, nullifyEmptyFormValues(value)])
  )
}

export const setNestedFormValue = (obj: any, path: string, value: any) => {
  const keys = path.split('.')
  const lastKey = keys.pop()
  const target = keys.reduce((acc, key) => (acc[key] = acc[key] || {}), obj)
  target[lastKey] = value
  return { ...obj }
}
